import React from "react";
import PropTypes from "prop-types";
import { MSelect } from "components/Shared";

const ValueSelector = (props) => {
  const { value, options, className, handleOnChange, title, style } = props;

  const quickListEditSelector = () => document.querySelector(".QuickListEdit");
  const onChange = e => handleOnChange(e.name || e.value);

  return (
    <div className={className} style={style}>
      <MSelect
        {...{ value, title, options }}
        onChange={onChange}
        getMenuPortalTarget={quickListEditSelector}
        noPadding={true}
        isClearable={false}
      />
    </div>
  );
};

ValueSelector.displayName = "ValueSelector";

ValueSelector.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  options: PropTypes.array.isRequired,
  className: PropTypes.string,
  handleOnChange: PropTypes.func,
  title: PropTypes.string,
  style: PropTypes.object,
};

export default ValueSelector;